import { useTranslation } from 'react-i18next'
import { Box, Stack, Text, TextLinkButton, Divider, Skeleton } from '@machobear/design-system'

const SummaryItems = () => {
  const { t } = useTranslation()

  return (
    <Stack space="small">
      <Box display="flex" justifyContent="spaceBetween" alignItems="center">
        <Skeleton.Shape height={11} width={'70%'} />
        <Skeleton.Shape height={11} width={'25%'} />
      </Box>
      <Divider />
      <Box display="flex" justifyContent="spaceBetween" alignItems="center">
        <Text size="small" tone="secondary">
          {t('b.payment.view.subtotal.label', 'Subtotal')}
        </Text>

        <Skeleton.Shape height={11} width={'25%'} />
      </Box>
      <Box display="flex" justifyContent="spaceBetween" width="full">
        <TextLinkButton onClick={() => {}}>Add coupon</TextLinkButton>
      </Box>
      <Box display="flex" justifyContent="spaceBetween" alignItems="center">
        <Text size="xsmall" tone="tertiary">
          GST/HST
        </Text>
        <Skeleton.Shape height={11} width={'25%'} />
      </Box>
      <Divider weight="strong" />
      <Box display="flex" justifyContent="spaceBetween">
        <Text size="standard" weight="strong">
          {t('common.total', 'Total')}
        </Text>
        <Skeleton.Shape height={11} width={'25%'} />
      </Box>
    </Stack>
  )
}

export default SummaryItems
